import style from "./style.scss";
import buttonStyles from "../link/style.scss"; //TODO: Make form button component
import { useState, useRef, useEffect } from "preact/hooks"; // Changed import
import { h } from "preact"; // Changed import
import { mergeClasses } from "../helpers";

// Helper function to check if the top of an element is in view
const isTopInViewport = (el) => {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  // Check if the top of the element is within the viewport's vertical bounds
  return (
    rect.top >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight)
  );
};

const Expandable = ({ expandText, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const panelRef = useRef(null);

  const toggleExpand = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen && panelRef.current) {
      // Use requestAnimationFrame to ensure the DOM has updated
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // Only scroll if the top of the element is not already in view
          if (!isTopInViewport(panelRef.current)) {
            panelRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
      });
    }
  }, [isOpen]);

  return (
    <div
      class={mergeClasses([style.expandable, isOpen ? style.expanded : null])}
      ref={panelRef}
    >
      {children}
      {isOpen ? null : (
        <div class={style.controls}>
          <button
            class={mergeClasses([buttonStyles.button, buttonStyles.medium])}
            onClick={toggleExpand}
          >
            <span class={buttonStyles.text}>{expandText}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Expandable;
